export const allMessages = "allMessages";
export const techSupport = "techSupport";
export const generalHelp = "generalHelp";

export const ALL_MESSAGES = "All messages";
export const INKLE_TEAM_AND_CPA_TEAM = "INKLE_TEAM, CPA_TEAM";
export const INKLE_TEAM = "INKLE_TEAM";
export const CPA_TEAM = "CPA_TEAM";

export const NOCHANNELFORASSIGNTOYOU = "NOCHANNELFORASSIGNTOYOU";
export const GENERAL_HELP = "/chat/generalhelp";

export const NEW_MESSAGE_COUNT_UPDATE = "NEW_MESSAGE_COUNT_UPDATE";
export const CHAT_TICKET = "Tickets";

export const ANNOUNCEMENTS_CHANNEL = "ANNOUNCEMENTS_CHANNEL";
export const AI_CHANNEL = "AI_AGENT";
export const MESSAGE_TYPE_DELETED = "deleted";
export const MESSAGE_TYPE_SYSTEM = "system";

export const DELETED_MESSAGE_TEXT = "This message was deleted";

export const CHAT_ORIGIN_TYPE = {
  MESSAGE: "MESSAGE",
} as const;

export type ChatOriginType =
  (typeof CHAT_ORIGIN_TYPE)[keyof typeof CHAT_ORIGIN_TYPE];
export const CHAT_CARD_TYPE = "card_type";
export const TASK_REVIEW_DOCUMENT = "TASK_REVIEW_DOCUMENT";
export const TASK_REVIEW_AND_PAY = "TASK_REVIEW_AND_PAY";
export const TASK_ADDITIONAL_PAYMENT = "TASK_ADDITIONAL_PAYMENT";
export const TASK_AMENDMENT_COMPLETED = "TASK_AMENDMENT_COMPLETED";
export const TICKET_CARD = "TICKET_CARD";
export const CALL_LOG_CUSTOM_TYPE = "CALL_LOG_CUSTOM_TYPE";

export const CUSTOMER_FEEDBACK_CUSTOM_TYPE = "CUSTOMER_FEEDBACK_CUSTOM_TYPE";
export const OPEN_ITEM_CUSTOM_TYPE = "OPEN_ITEM_CUSTOM_TYPE";
export const REQUESTED_INFO_CUSTOM_TYPE = "REQUESTED_INFO_CUSTOM_TYPE";
export const ESIGN_REQUEST_CUSTOM_TYPE = "ESIGN_REQUEST_CUSTOM_TYPE";
export const REQUESTED_ANSWERS_CUSTOM_TYPE = "REQUESTED_ANSWERS_CUSTOM_TYPE";
export const FINANCIAL_CLOSING = "Financial Closing";
export const REQUESTED_REVIEW_DRAFT_TYPE = "REQUESTED_REVIEW_DRAFT_TYPE";
export const REQUESTED_DFT_REVIEW_TYPE = "REQUESTED_DFT_REVIEW_TYPE";
export const REVIEW_DRAFT_BILL = "REVIEW_DRAFT_BILL";
export const REVIEW_DRAFT_INVOICE = "REVIEW_DRAFT_INVOICE";

export const REQUESTED_DOCUMENTS_CUSTOM_TYPE =
  "REQUESTED_DOCUMENTS_CUSTOM_TYPE";

export const SENSITIVE_DATA_CUSTOM_TYPE = "SENSITIVE_DATA_CUSTOM_TYPE";

export const PRICED_TICKET_CARD = "PRICED_TICKET_CARD";

export const TRANSACTIONS = "TRANSACTIONS";
export const CART = "CART";

export const FINANCIAL_CLOSING_CARD_TYPE = {
  CLARIFICATION_RAISED: "CLARIFICATION_RAISED",
  REVIEW_FINANCIAL: "REVIEW_FINANCIAL",
} as const;

export const CLOSING_DOCUMENT_SUMMARY_CUSTOM_TYPE =
  "CLOSING_DOCUMENT_SUMMARY_CUSTOM_TYPE";

export const MERCHANT_EMAIL_REQUEST_CUSTOM_TYPE = "MERCHANT_EMAIL_REQUEST";

export const REVIEW_AI_RECONCILIATION = "REVIEW_AI_RECONCILIATION";

export const COMMENT_CARD_CUSTOM_TYPE = "COMMENT_CARD_CUSTOM_TYPE";

export const ACCOUNTANT_ACCESS_REQUEST_CARD_TYPE = "ACCOUNTANT_ACCESS_REQUEST";

export const ESTIMATED_TAX_QUARTERLY_CARD_TYPE = "ESTIMATED_TAX_QUARTERLY_CARD";

export const MEETING_REQUEST_CUSTOM_TYPE = "MEETING_REQUEST_CUSTOM_TYPE";

export const AI_QUESTION_CARD_CUSTOM_TYPE = "AI_QUESTION_CARD";

export const CREATE_ENTITY_CARD_CUSTOM_TYPE = "CREATE_ENTITY_CARD";

export const KB_SEARCH_CHANNEL = "KB_SEARCH";

export const MESSAGE_SOURCE = {
  COMPLETE_WITH_AI_CHAT_MESSAGE: "COMPLETE_WITH_AI_CHAT_MESSAGE",
} as const;
